import { Subscribable } from '@benzinga/subscribable';
import { GovernmentMember, GovernmentTrade, MembersOverview } from './entities';
import { GovTradesManagerEvent } from './manager';

export class GovTradesStore extends Subscribable<GovTradesManagerEvent> {
  private members: MembersOverview;
  private trades: GovernmentTrade[];
  private cachedGovernmentMemberList: GovernmentMember[];

  constructor() {
    super();
    this.members = {} as MembersOverview;
    this.trades = [];
    this.cachedGovernmentMemberList = [];
  }

  public getCachedMembers = (): MembersOverview => this.members;
  public getCachedTrades = (): GovernmentTrade[] => this.trades;
  public getCachedGovernmentMemberList = (): GovernmentMember[] => this.cachedGovernmentMemberList;

  public getCachedMemberById = (id: string): GovernmentMember | undefined =>
    this.members.congressional_members?.find(member => member.id === id);

  updateMembers = (members: MembersOverview): MembersOverview => {
    this.members = members;
    this.dispatch({
      members,
      type: 'gov_trades:update_members',
    });
    return members;
  };

  updateTrades = (trades: GovernmentTrade[]) => {
    this.trades = trades;
    this.dispatch({
      trades,
      type: 'gov_trades:update_trades',
    });
  };

  updateGovernmentMemberCachedList = (member: GovernmentMember) => {
    this.cachedGovernmentMemberList.push(member);
    this.dispatch({
      members: this.members,
      type: 'gov_trades:update_members',
    });
    return this.cachedGovernmentMemberList;
  };
}
